import { Component } from '@angular/core';

@Component({
  selector: 'app-es-tos-contents',
  templateUrl: './es-tos-contents.component.html',
})
export class CastilianTOSContentsComponent {}
